<!-- src/App.vue -->
<template>
  <Contact />
</template>

<script setup>
import Contact from "../components/Contact";

import { useHead } from '@vueuse/head'

useHead({
  title: 'Grapefroot | Contact Us',
  meta: [
    {
      name: 'description',
      content: 'Meta description',
    },
  ],
})


</script>
